import { LinkedOptionSet } from '@extTypes/enums/option-sets';

export const linkedOptionSets = [
    {
        value: LinkedOptionSet.All,
        text: 'All option sets'
    },
    {
        value: LinkedOptionSet.Linked,
        text: 'Linked to Product'
    },
    {
        value: LinkedOptionSet.NotLinked,
        text: 'Not linked to Product'
    }
];
